import { c as _c } from "react/compiler-runtime";
import { Box } from '@mui/material';
import type { StructuredContentDocument, StructuredContentDocumentWithRenderer } from '../../hydration/types';
import { renderStructuredContent } from '../../renderContext';
export type DocumentProps = StructuredContentDocumentWithRenderer<{
  spacing?: {
    top?: number;
    bottom?: number;
  };
  inline?: boolean;
  children: StructuredContentDocument;
}>;
export const Document = t0 => {
  const $ = _c(8);
  const {
    props
  } = t0;
  if (props.inline) {
    let t1;
    if ($[0] !== props.children) {
      t1 = renderStructuredContent(props.children);
      $[0] = props.children;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== t1) {
      t2 = <>{t1}</>;
      $[2] = t1;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  let t1;
  if ($[4] !== props.children) {
    t1 = renderStructuredContent(props.children);
    $[4] = props.children;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== t1) {
    t2 = <Box>{t1}</Box>;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};